










import { defineComponent } from '@vue/composition-api';
import { userProfileLink } from '@front-app/util/links';

export default defineComponent({
	props: {
		userId: {
			type: String,
			required: true,
		},
	},
	setup() {
		return { userProfileLink };
	},
});
